module.exports = __webpack_public_path__ + "img/services.6a87e320.svg";